<div class="modal-header">
  <h2>
    {{cabecalho}}
  </h2>
</div>
<div class="modal-body">
  <label for="justificativa">Informe a justificativa</label>
  <textarea [formControl]="justificativa" name="justificativa" id="justificativa" rows="2" class="form-control"></textarea>
  <app-msg-erro [control]="justificativa"></app-msg-erro>
</div>
<div class="modal-footer d-flex justify-content-between">
  <button (click)="activeModal.close(false)" class="btn btn-secondary px-lg-5">Cancelar</button>
  <button (click)="activeModal.close(justificativa.value)" [disabled]="justificativa.invalid" class="btn btn-success px-5">Confirmar</button>
</div>
